import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import EditableField from "../../utils/editable_text_field";

export default function DashTournamentsDetails() {
  const location = useLocation();
  const [tournament, setTournament] = useState(null);
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [city, setCity] = useState("");
  const [locationTournament, setLocationTournament] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabFromUrl = urlParams.get("tab");
    let id = null;

    if (tabFromUrl && tabFromUrl.startsWith("tournamentsDetails/")) {
      id = tabFromUrl.split("/")[1];
    }

    if (id) {
      const fetchTournamentDetails = async () => {
        try {
          const response = await fetch(
            `https://server-postgre.vercel.app/tournaments/${id}`
          );
          if (!response.ok) {
            throw new Error("Error fetching tournament details");
          }
          const data = await response.json();
          setTournament(data);
          setName(data.name);
          setType(data.type);
          setStartDate(data.start_date);
          setEndDate(data.end_date);
          setCity(data.city);
          setLocationTournament(data.location);
        } catch (error) {
          console.error("Error fetching tournament details:", error);
        }
      };

      fetchTournamentDetails();
    }
  }, [location]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSave = async () => {
    try {
      const response = await fetch(
        `https://server-postgre.vercel.app/tournaments/${tournament.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name,
            type,
            startDate,
            endDate,
            city,
            location: locationTournament,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Error updating tournament details");
      }

      // Refrescar los detalles del torneo después de la actualización
      const updatedTournament = await response.json();
      setTournament(updatedTournament);
    } catch (error) {
      console.error("Error updating tournament details:", error);
    }
  };

  if (!tournament) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white rounded-xl shadow-md space-y-4 flex">
      <div className="mr-6">
        <h2 className="text-3xl mb-3 font-bold text-gray-900">
          Tournament Details
        </h2>
        <img
          src={`https://server-postgre.vercel.app/${tournament.photo_url}`}
          alt="Torneo"
          className="w-40 rounded-md shadow-lg"
        />
      </div>
      <div className="items-center">
        <EditableField
          label="Name"
          value={name}
          onEdit={(newValue) => setName(newValue)}
        />
        <EditableField
          label="Type"
          value={type}
          onEdit={(newValue) => setType(newValue)}
        />
        <EditableField
          label="Start Date"
          value={formatDate(startDate)}
          onEdit={(newValue) => setStartDate(newValue)}
        />
        <EditableField
          label="End Date"
          value={formatDate(endDate)}
          onEdit={(newValue) => setEndDate(newValue)}
        />
        <EditableField
          label="City"
          value={city}
          onEdit={(newValue) => setCity(newValue)}
        />
        <EditableField
          label="Location"
          value={locationTournament}
          onEdit={(newValue) => setLocationTournament(newValue)}
        />
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          onClick={handleSave}
        >
          Guardar
        </button>
      </div>
    </div>
  );
}
